import React, { useRef, useCallback } from "react";
import { Modal } from "react-bootstrap";
import AsyncSelect from 'react-select/async';
import { toast } from "react-toastify";
import api from "../../../../api/api";

const selectStyle = {
    theme: theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: '#92278f',
            primary: '#92278f',
        },
    })
};

const MoveClassRoomModal = ({ show, onClose, user, onSubmit, promiseClassRoomOptions, onSuccess, t }) => {
    const classRoomSelectRef = useRef(null);

    const handlePromiseClassRoomOptions = useCallback((inputValue, callback) => {
        if (promiseClassRoomOptions) {
            promiseClassRoomOptions(inputValue, callback, user);
            return;
        }
        if (!user?.School?.Id) {
            callback([]);
            return;
        }
        api.post(`/ClassRoomsLookups/`, {
            Name: inputValue,
            SchoolId: user.School.Id,
        })
            .then((resp) => {
                if (resp.data.data?.length > 0) {
                    callback(
                        resp.data.data.map((p) => ({
                            label: p.ClassType.Name + " " + p.Division.Name,
                            value: p.Id,
                        }))
                    );
                } else {
                    callback([]);
                }
            })
            .catch(() => callback([]));
    }, [promiseClassRoomOptions, user]);

    if (!show) return null;

    const handleSaveClassRoom = () => {
        const selected = classRoomSelectRef.current?.select?.select?.getValue();
        const value = selected && selected[0]?.value;

        if (onSubmit) {
            onSubmit(value);
            return;
        }

        const _toastId = toast(t("Processing"), { position: "bottom-left", autoClose: false });
        api.post(`/ChangeStudentClass/${user.Id}`, { ClassRoomId: value })
            .then(() => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"><i className="icon fal fa-exchange"></i>{t("Pages.UsersControl.toast.ChangeClassRoom.Title")}</div></div>,
                    type: toast.TYPE.SUCCESS,
                    autoClose: 5000,
                });
                if (onSuccess) onSuccess();
                onClose();
            })
            .catch(() => {
                toast.update(_toastId, {
                    render: () => <div><div className="h5"><i className="icon fal fa-wifi-slash"></i> {t("Error.NoConnection.Title")}</div></div>,
                    type: toast.TYPE.ERROR,
                    autoClose: 5000,
                });
            });
    };

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-exchange text-primary icon ml-2"></i>
                        {t("Pages.StudentInClassRoomsControl.action.move")}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category mb-2">
                    <div className="widget-body">
                        <div className="form-group w-100">
                            <AsyncSelect
                                cacheOptions
                                isClearable={true}
                                name="ClassRoomId"
                                placeholder={t('Pages.ClassRoomsControl.title')}
                                isRtl={true}
                                isSearchable={true}
                                defaultOptions
                                loadOptions={handlePromiseClassRoomOptions}
                                ref={classRoomSelectRef}
                                {...selectStyle}
                            />
                        </div>
                        <div className="form-group w-100 text-center">
                            <button className="custom-button btn-block" onClick={handleSaveClassRoom}>
                                <span>
                                    <i className="icon fal fa-exchange ml-1"></i>
                                    {t('Pages.StudentInClassRoomsControl.action.move_action')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MoveClassRoomModal;
